import ActionMetaBuilder from 'storeState/ActionMetaBuilder';

export const PREFIX = "GENERALS";

export const actionMeta = new ActionMetaBuilder(PREFIX);

actionMeta.defineRequest({
  name: "general_base",
  urlBuilder: () => 'general/base'
});



// WEBPACK FOOTER //
// ./src/storeState/general/meta.js